let activeDbName = "spuerhund";
let switchCallback: (() => Promise<void>) | null = null;

export function getActiveDbName(): string {
  return activeDbName;
}

export function setActiveDbName(name: string): void {
  activeDbName = name;
}

export function getSignedInDbName(userId: string): string {
  return `spuerhund-user-${userId}`;
}

export function onDbSwitch(callback: () => Promise<void>): void {
  switchCallback = callback;
}

export async function switchToSignedInDb(userId: string): Promise<void> {
  activeDbName = getSignedInDbName(userId);
  if (switchCallback) await switchCallback();
}

export async function switchToAnonymousDb(): Promise<void> {
  activeDbName = "spuerhund";
  if (switchCallback) await switchCallback();
}
